type StatusBadgeProps = {
  level: string;
  status: string;
};

const styles: Record<string, string> = {
  good: "bg-secondary-100 text-secondary-800",
  warn: "bg-primary-100 text-primary-700",
  bad: "bg-accent-100 text-accent-700",
};

export default function StatusBadge({ level, status }: StatusBadgeProps) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-1 text-xs ${styles[level] ?? styles.good}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {status}
    </span>
  );
}